import React, { useCallback } from 'react';
import { isEmpty } from '../../../helpers/common';
import { rootStore } from '../../../mobx/rootStore';
import { CreateProjectInput } from '../../../mobx/stores/projectStore';
import CreateNewProjectModalV2 from '../../modals/createNewProjectModal';
import CreateTaskModalV2 from '../../modals/createTaskModal';
import DeleteModal from '../../modals/deleteModal';
import Milestonemodal from '../../modals/milestoneModal';
import Modal from '../../modals/modal';
import ModalHeader from '../../modals/modalHeader';
import { useAccountingModals } from '../../../hooks/accounting/useAccountingModals';

type AccountingModalControls = ReturnType<typeof useAccountingModals>;

interface AccountingModalsProps {
  archiveProject: () => Promise<void>;
  createProjectInput: CreateProjectInput;
  loadData: (forceReload?: boolean) => void;
  loading: boolean;
  params: { id: string };
  loadTaskList?: () => void;
  modalState: AccountingModalControls;
}

const AccountingModals: React.FC<AccountingModalsProps> = ({
  archiveProject,
  createProjectInput,
  loadData,
  loading,
  params,
  loadTaskList,
  modalState
}) => {
  const { closeModal, closeProjectModals, modals, openModal } = modalState;
  const { customerId, name } = createProjectInput || {};

  const closeEditProjectModal = useCallback(() => {
    closeProjectModals();
    rootStore.projectStore.createProjectInput.clear();
  }, [closeProjectModals]);

  const cancelProjectModal = useCallback(() => {
    if (!isEmpty(name) || customerId) {
      openModal('confirmation');
      return;
    }
    closeEditProjectModal();
  }, [closeEditProjectModal, customerId, name, openModal]);

  return (
    <>
      <Modal open={modals.task} onClose={() => closeModal('task')} maxWidth='680px' isCreateTask={true}>
        <CreateTaskModalV2 loadData={loadTaskList} onCancel={() => closeModal('task')} />
      </Modal>
      <Modal open={modals.archive} onClose={() => closeModal('archive')} maxWidth='334px'>
        <DeleteModal
          onClose={() => closeModal('archive')}
          onOk={archiveProject}
          isArchive={true}
          loading={loading}
          modalTitle='Archive Project'
          description='Confirming archive? You can restore it later if needed.'
        />
      </Modal>
      <Modal open={modals.project} onClose={cancelProjectModal} maxWidth='632px' isResponsiveMaxWidth={true} overflow='visible'>
        <ModalHeader title='Edit Project' onClose={cancelProjectModal} />
        <CreateNewProjectModalV2
          handleCloseModal={closeEditProjectModal}
          onClickCancel={cancelProjectModal}
          loadProjectData={() => loadData(true)}
        />
      </Modal>
      <Modal open={modals.milestone} onClose={() => closeModal('milestone')} maxWidth='462px'>
        <Milestonemodal onClose={() => closeModal('milestone')} projectId={params.id} />
      </Modal>
      <Modal open={modals.confirmation} onClose={() => closeModal('confirmation')} maxWidth='334px'>
        <DeleteModal
          isYes={true}
          onClose={() => closeModal('confirmation')}
          onOk={closeEditProjectModal}
          modalTitle='Confirmation Model'
          description='Are you sure you want close this model?'
        />
      </Modal>
    </>
  );
};

export default AccountingModals;
